import CryptoJS from "crypto-js";
import { ENV_ENCRYPTION_KEY } from "../config";
const toHexString = (bytes) => {
  return Array.from(bytes, (byte) => {
    return ('0' + (byte & 0xff).toString(16)).slice(-2);
  }).join('');
}

export function decryptor(cipherData) {
  let text = {};
  if (cipherData.length === 2) {
    text = {
      iv: toHexString(cipherData[0].data),
      encrypted: toHexString(cipherData[1].data)
    }
  } else {
    return {}
  }
  // Convert IV and encrypted data to CryptoJS format
  const ivBytes = CryptoJS.enc.Hex.parse(text.iv);
  const encryptedBytes = CryptoJS.enc.Hex.parse(text.encrypted);
  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: encryptedBytes,
    iv: ivBytes,
  });
  // Decrypt the data
  const decrypted = CryptoJS.AES.decrypt(
    cipherParams,
    CryptoJS.enc.Utf8.parse(ENV_ENCRYPTION_KEY),
    { iv: ivBytes, padding: CryptoJS.pad.Pkcs7 }
  );
  // Convert the decrypted data to a string
  const decryptedData = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData)
}

function coverter(words) {
  const ivUint8Array = new Uint8Array(words.length * 4);
  for (let i = 0; i < words.length; i++) {
    ivUint8Array[i * 4] = (words[i] >> 24) & 0xff;
    ivUint8Array[i * 4 + 1] = (words[i] >> 16) & 0xff;
    ivUint8Array[i * 4 + 2] = (words[i] >> 8) & 0xff;
    ivUint8Array[i * 4 + 3] = words[i] & 0xff;
  }
  return ivUint8Array;
}

export function encryptor(data) {
  let iv = CryptoJS.lib.WordArray.random(16);
  // Encrypt the data
  const ciphertext = CryptoJS.AES.encrypt(
    `${JSON.stringify(data)}`,
    CryptoJS.enc.Utf8.parse(ENV_ENCRYPTION_KEY),
    { iv, padding: CryptoJS.pad.Pkcs7 }
  );
  const datas = CryptoJS.enc.Base64.parse(ciphertext.toString())
  iv = coverter(iv.words)
  const encryptedData = coverter(datas.words)
  // Convert IV and encrypted data to buffer format
  return [
    Array.from(iv),
    Array.from(encryptedData)
  ]
}